<template>
  <v-container fluid>
    <v-row class="flex-grow-0 px-4">
      <v-col>
        <v-select :label="$t('booking.facility')"
                  :items="facilityTypeOptions"
                  v-model="selectedFacilityType"></v-select>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1 px-4">
      <v-col>
        <RemotePaginatedList :headers="headers"
                             multi-sort
                             v-model="selectedItemIds"
                             data-url="aafb/booking/"
                             data-key="bookings"
                             :extra-filters="extraFilters"
                             :refresh-trigger.sync="innerRefreshTrigger"
                             :no-data-text="$t('booking.no_booking')"
                             v-bind="$attrs">
          <template v-slot:item.create_at="{value}">
            {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
          </template>
          <template v-slot:item.facility="{item}">
            {{ `${$parseDate(item.start_time, 'yyyy-MM-dd HH:mm')} - ${$parseDate(item.end_time, 'HH:mm')} ${item.item.name}` }}
          </template>
          <template v-slot:item.status="{item}">
            {{ $t(BOOKING_STATUS_LABEL[item.status]) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon color="primary"
                   :to="{name: 'booking-detail', params: {bookingRecordId: item.id}}">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
<!--            <v-btn icon color="primary"-->
<!--                   :to="{name: 'booking-preview', params: {bookingRecordId: item.booking_record.id}}"-->
<!--                   v-if="item.status === 0">-->
<!--              <v-icon>mdi-cash-register</v-icon>-->
<!--            </v-btn>-->
          </template>
        </RemotePaginatedList>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {ref, watch, onMounted, computed} from '@vue/composition-api';
import _ from 'lodash';
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import {DateTime} from "luxon";

export default {
  name: 'UserBookingList',
  components: {RemotePaginatedList},
  props: {
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const innerRefreshTrigger = ref(false);
    const refresh = async function () {
      getFacilityTypes();
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Facility Type
    const facilityTypes = ref([]);
    const getFacilityTypes = function () {
      root.$callAPI('aafb/facility_types/', {}, function (response) {
        facilityTypes.value = response.body.item_types;
      });
    };
    const facilityTypeOptions = computed(()=> {
      return _.concat([{value: null, text: root.$t('all')}], _.filter(facilityTypes.value, 'open_for_booking').map((t) => {
        return {value: t.id, text: t.name};
      }));
    });
    const selectedFacilityType = ref(null);
    const extraFilters = computed(()=> {
      let filters = {};

      if (selectedFacilityType.value) {
        filters['item.type.id'] = [selectedFacilityType.value];
      }

      return filters
    });

    // Data Table
    const headers = computed(() => [
      {text: root.$t('booking.create_at'), value: 'create_at'},
      {text: root.$t('booking.facility'), value: 'facility', sortable: false},
      {text: root.$t('booking.status'), value: 'status'},
      {text: '', value: 'actions', sortable: false},
    ]);
    const filterOptions = computed(()=> {
      return [
        {text: root.$t('booking.create_at'), value: 'create_at', date_range: true},
        {
          text: root.$t('booking.facility'), value: 'item.type.id',
          options: _.filter(facilityTypes.value, 'open_for_booking').map((t) => {
            return {value: t.id, text: t.name};
          }),
        },
        {
          text: root.$t('booking.status'), value: 'status',
          options: [
            {value: BOOKING_STATUS.RESERVED, text: root.$t('booking_status.reserved')},
            {value: BOOKING_STATUS.CONFIRMED, text: root.$t('booking_status.confirmed')},
            {value: BOOKING_STATUS.CANCELLED_BY_USER, text: root.$t('booking_status.cancelled_by_user')},
            {value: BOOKING_STATUS.REFUNDED, text: root.$t('booking_status.refunded')},
            {value: BOOKING_STATUS.CANCELLED_BY_ADMIN, text: root.$t('booking_status.cancelled_by_admin')},
            {value: BOOKING_STATUS.EXPIRED, text: root.$t('booking_status.expired')},
            {value: BOOKING_STATUS.NO_SHOW, text: root.$t('booking_status.no_show')},
          ]
        },
      ]
    });

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    const editItem = function (item) {
      emit('edit', item);
    };

    return {
      facilityTypeOptions,
      selectedFacilityType,
      extraFilters,

      filterOptions,
      innerRefreshTrigger,

      headers,
      selectedItemIds,

      editItem,

      DateTime,

      BOOKING_STATUS_LABEL,
    }
  }
}
</script>
